import '../Sass/App.scss';
import React, { useState } from 'react';
import { Card } from './Card2';
import { Modify } from './Modify';
import { useDrop } from 'react-dnd';
import Dialog from '@mui/material/Dialog';

export function ProgramGroup (props) {

    const [modalOpen, setModalOpen] = useState(false)
    const [cardInFocus, setCardInFocus] = useState({cardData: null, indexInSeries: null})
    const [modifyOpen, setModifyOpen] = useState(false)
    const [flipped, setFlipped] = useState(false)

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card','ml-card','viral-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            item.sendHandler(dragIndex, 1)
            addToHand(item.cardData, 0)
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    function reorder(dragIndex, dropIndex) {
        const programs = [...props.programs]
        if (dragIndex.groupIndex == dropIndex.groupIndex && dragIndex.programIndex == dropIndex.programIndex) {
            const currentProgramGroup = [...programs[dragIndex.programIndex][dragIndex.groupIndex]]
            const updatedHand = []
            currentProgramGroup.forEach((card, index) => {
                if (dragIndex.cardIndex > dropIndex.cardIndex && dropIndex.cardIndex < index && index <= dragIndex.cardIndex) {
                    index == (dropIndex.cardIndex + 1) ? updatedHand[index] = currentProgramGroup[dragIndex.cardIndex] : updatedHand[index] = currentProgramGroup[index-1]
                } else if (dragIndex.cardIndex < dropIndex.cardIndex && dropIndex.cardIndex >= index && index >= dragIndex.cardIndex) {
                    index == dropIndex.cardIndex ? updatedHand[index] = currentProgramGroup[dragIndex.cardIndex] : updatedHand[index] = currentProgramGroup[index+1]
                } else {
                    updatedHand[index] = currentProgramGroup[index]
                }
            })
            props.setCards(rebuildProgramInfo(updatedHand, dragIndex.groupIndex, dragIndex.programIndex, programs))
        } else {
            
            const programGroupToEnlarge = [...programs[dropIndex.programIndex][dropIndex.groupIndex]]
            const cardToAdd = programs[dragIndex.programIndex][dragIndex.groupIndex][dragIndex.cardIndex]
            const enlargedProgramGroup = [
                ...programGroupToEnlarge.slice(0, dropIndex.cardIndex+1), 
                cardToAdd, 
                ...programGroupToEnlarge.slice(dropIndex.cardIndex+1, programGroupToEnlarge.length)
            ]
            const enlargedPrograms = rebuildProgramInfo(enlargedProgramGroup, dropIndex.groupIndex, dropIndex.programIndex, programs)
            const programGroupToReduce = [...enlargedPrograms[dragIndex.programIndex][dragIndex.groupIndex]]
            const reducedProgramGroup = [
                ...programGroupToReduce.slice(0,dragIndex.cardIndex),
                ...programGroupToReduce.slice(dragIndex.cardIndex+1, programGroupToReduce.length)
            ]
            props.setCards(rebuildProgramInfo(reducedProgramGroup, dragIndex.groupIndex, dragIndex.programIndex, enlargedPrograms))
        }

    }

    function removeFromHand(dragIndex) {
        const cardIndex = dragIndex.cardIndex
        const currentProgramGroup = [...props.programs[props.programIndex][props.groupIndex]]
        const newGroup = [
            ...currentProgramGroup.slice(0,cardIndex),
            ...currentProgramGroup.slice(cardIndex+1, currentProgramGroup.length)
        ];
        const newPrograms = rebuildProgramInfo(newGroup, props.groupIndex, props.programIndex, props.programs)
        props.setCards(newPrograms)
        setModalOpen(false)
        return newPrograms
    }

    function addToHand(card, dropIndex) {
        const position = dropIndex.cardIndex
        const currentProgramGroup = [...props.programs[props.programIndex][props.groupIndex]]
        const newGroup = [
            ...currentProgramGroup.slice(0, position+1), 
            card, 
            ...currentProgramGroup.slice(position+1, currentProgramGroup.length)
        ]       
        props.setCards(rebuildProgramInfo(newGroup, props.groupIndex, props.programIndex, props.programs))
    }

    function rebuildProgramInfo(newGroup, groupIndex, programIndex, programs) {
        const rebuiltProgramGroups = [
            ...programs[programIndex].slice(0,groupIndex),
            newGroup,
            ...programs[programIndex].slice(groupIndex+1, programs[programIndex].length),
        ]
        const rebuiltPrograms = [
            ...programs.slice(0,programIndex),
            rebuiltProgramGroups,
            ...programs.slice(programIndex+1,programs.length),
        ]
        return rebuiltPrograms
    }

    function expandCard(cardData, indexInSeries) {
        setCardInFocus({ cardData: cardData, indexInSeries: indexInSeries })
        setModalOpen(true)
    }

    function modifyCard() {
        setModalOpen(false)
        setModifyOpen(true)
    }

    function flipCard(e) {
        flipped == 0 ? setFlipped(1) : setFlipped(0)
        e.stopPropagation()
    }

    function increaseRotation(cardIndex) {
        const newCard = props.programs[props.programIndex][props.groupIndex][cardIndex.cardIndex]
        newCard.rotation = newCard.rotation + 90
        const currentProgramGroup = [...props.programs[props.programIndex][props.groupIndex]]
        const newGroup = [
            ...currentProgramGroup.slice(0, cardIndex.cardIndex), 
            newCard, 
            ...currentProgramGroup.slice(cardIndex.cardIndex+1, currentProgramGroup.length)
        ]       
        props.setCards(rebuildProgramInfo(newGroup, props.groupIndex, props.programIndex, props.programs))
    }

    function changeCardData(cardIndex, newData) {
        const currentProgramGroup = [...props.programs[props.programIndex][props.groupIndex]]
        const newGroup = [
            ...currentProgramGroup.slice(0, cardIndex.cardIndex), 
            newData, 
            ...currentProgramGroup.slice(cardIndex.cardIndex+1, currentProgramGroup.length)
        ]       
        props.setCards(rebuildProgramInfo(newGroup, props.groupIndex, props.programIndex, props.programs))
        setModifyOpen(false)
    }



    return (
        <>
        <div style={{display: 'block', float: 'left', maxWidth: props.cardWidth + 20, minWidth: ((props.cardWidth + 11 - (props.cardWidth / 1.5)) * props.cards.length) + (props.cardWidth / 1.25)}}>
            { props.cards.length > 0 ? props.cards.map((card, index) =>
                <Card currentHome={props.currentHome} clickHandler={expandCard} sendHandler={removeFromHand} reorderHandler={reorder} receiveHandler={addToHand} cardData={card} codebase={props.codebase} cardWidth={props.cardWidth} cardStyle='programGroup' key={index} indexInSeries={{programIndex: props.programIndex, groupIndex: props.groupIndex, cardIndex: index }} flipped={flipped} flipHandler={ card.flippable == 1 ? flipCard : false } />
            ) : null }
        </div>
        <Dialog
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            PaperProps={{sx: {bgcolor: 'transparent'}}}
            >
                <Card cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} cardWidth={500} showQuantity={false} options={true} sendHandler={removeFromHand} rotateHandler={increaseRotation} modifyHandler={modifyCard} flipped={flipped} notDraggable />
                <button className="close-button" style={{right: 0, top: 0, zIndex: 2500}} onClick={() => setModalOpen(false)}>X</button>
        </Dialog>
        <Dialog
            open={modifyOpen}
            maxWidth='xl'
            fullWidth={true}
            onClose={() => setModifyOpen(false)}
            PaperProps={{sx: {bgcolor: 'black', border: 1, borderColor: 'white', padding: 3, color: 'white'}}}
            >
                <Modify cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} changeHandler={changeCardData} setModifyOpen={setModifyOpen} />
        </Dialog>
        </>
    )

}
